/**
 * Node Type Utilities
 *
 * `type` — single invariant value that drives component/parser selection (e.g. 'text', 'questionnaire').
 * `tags` — descriptive classification labels used for grouping/filtering (e.g. 'idea', 'question').
 *
 * getNodeType() provides backward compatibility for nodes created before the `type` field was
 * introduced, where 'questionnaire' was stored in `tags` instead of `type`.
 */

/**
 * Returns the structural type of a node.
 * Reads `node.type` when present; falls back to inferring type from legacy `tags` usage.
 *
 * @param {Object|null|undefined} node
 * @returns {string} node type, defaults to 'text'
 */
export function getNodeType(node) {
  if (!node) return 'text';
  if (node.type) return node.type;
  // Backward compat: 'questionnaire' was previously stored in tags
  if (node.tags === 'questionnaire') return 'questionnaire';
  return 'text';
}
